import LocalizedCharacterSet from './LocalizedCharacterSet';
/**
 * @module Validators
 * @overview This file contains factory function for different languages
 * so in order to use these checks, you need to instantiate it first
 * e.g.
 * import { createValidChars } from '4finance-validation';
 *
 * const country = createValidChars.COUNTRIES.CZ;
 * const { letters, lettersAndSpace, lettersAndNumbersAndSpace } = createValidChars(country);
 */

/**
 * @type {String}
 * @private
 * @const
 */

export var ERROR_LETTERS = 'letters_only';
/**
 * @type {String}
 * @private
 * @const
 */

export var ERROR_LETTERS_SPACE = 'letters_and_space_only';
/**
 * @type {String}
 * @private
 * @const
 */

export var ERROR_LETTERS_NUMBERS_SPACE = 'letters_and_numbers_and_space_only';

var createValidChars = function createValidChars(country) {
  var characterSet = new LocalizedCharacterSet(country).add('-', '\'');
  return {
    letters: characterSet.toValidator(ERROR_LETTERS),
    lettersAndSpace: characterSet.add('\\s').toValidator(ERROR_LETTERS_SPACE),
    lettersAndNumbersAndSpace: characterSet.add('\\d').toValidator(ERROR_LETTERS_NUMBERS_SPACE)
  };
};

createValidChars.COUNTRIES = LocalizedCharacterSet.COUNTRIES;
export default createValidChars;